import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PRODUCT } from "./data";
import MagicSparkles from "./MagicSparkles";

const STACK = [
  { label: "Curso completo — 6 módulos, 21 aulas em vídeo", value: "R$ 497,00" },
  {
    label: "Comunidade Mariana Mello — Lives, gravações e ecossistema (12 meses)",
    value: "R$ 497,00",
    highlight: true,
  },
];

export default function ValueStackSection() {
  return (
    <section className="relative py-28 bg-gradient-to-br from-[#3d2a5a] via-[#2d1f43] to-[#1f1430]">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12 max-w-2xl mx-auto"
        >
          <h2 className="font-display text-4xl lg:text-5xl text-white leading-tight">
            Tudo o que você leva
            <span className="block text-[#a78bfa] font-medium mt-2">
              por um único valor.
            </span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.04] to-white/[0.01] overflow-hidden backdrop-blur-sm"
        >
          {/* Stack: Course + Live Bonus */}
          <div className="divide-y divide-white/10">
            {STACK.map((row, i) => (
              <div
                key={i}
                className={`flex items-center justify-between px-6 lg:px-9 py-4 lg:py-5 ${row.highlight ? "bg-gradient-to-r from-[#fb7185]/10 to-transparent" : ""}`}
              >
                <span className="text-slate-200/85 text-[14.5px] lg:text-[15px] pr-4">
                  {row.label}
                </span>
                <span className="text-[#c4b5fd] font-semibold tabular-nums shrink-0 text-[15px]">
                  {row.value}
                </span>
              </div>
            ))}
            <div className="px-6 lg:px-9 py-5 bg-white/[0.05] flex items-center justify-between">
              <span className="text-white font-semibold text-base">
                Total se fosse comprar separado
              </span>
              <span className="text-white font-bold text-lg tabular-nums line-through opacity-60">
                {PRODUCT.priceOriginal}
              </span>
            </div>
          </div>

          {/* Highlighted price + CTA */}
          <div className="bg-gradient-to-br from-violet-500/20 via-violet-500/8 to-transparent p-9 lg:p-12 text-center border-t border-violet-400/25">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#c4b5fd] mb-5">
              Hoje você acessa tudo por
            </p>

            {/* PRIMARY: 12x parcela (responsive scale) */}
            <div className="mb-3 flex flex-wrap items-baseline justify-center gap-x-2 gap-y-1">
              <span className="font-display text-[46px] sm:text-[64px] lg:text-[88px] leading-none text-white font-medium tracking-tight">
                12x
              </span>
              <span className="font-display text-[24px] sm:text-[32px] lg:text-[44px] text-white/90">
                de
              </span>
              <span className="font-display text-[46px] sm:text-[64px] lg:text-[88px] leading-none text-white font-medium tracking-tight">
                R$&nbsp;51,40
              </span>
            </div>

            {/* SECONDARY: à vista */}
            <p className="text-slate-300/80 text-sm lg:text-base mb-9 font-body">
              ou {PRODUCT.priceFormatted} à vista
            </p>

            {/* HIGHEST CONTRAST CTA — coral/salmon (aligned with brand warmth) */}
            <a
              href={PRODUCT.checkoutUrl}
              data-testid="value-stack-cta"
              className="group relative btn-shine btn-jelly cta-pulse inline-flex items-center justify-center gap-2 bg-[#fb7185] text-white hover:bg-[#f43f5e] font-extrabold rounded-full px-12 py-5 text-[16px] lg:text-[18px] shadow-[0_25px_70px_-10px_rgba(251,113,133,0.55)] hover:shadow-[0_30px_80px_-10px_rgba(244,63,94,0.85)] tracking-tight"
            >
              <MagicSparkles />
              <span className="relative z-10">Quero acessar agora</span>
              <ArrowRight className="w-5 h-5 relative z-10 arrow-slide" />
            </a>
            <p className="text-sm text-violet-200/75 mt-6 max-w-md mx-auto px-4 leading-relaxed">
              Menos do que uma consulta particular com especialista em sono
              infantil.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
